import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

function ReglementsClubs() {
  return (
    <div className="container my-5">
      <h1 className="display-4 mb-4 text-center">Règlements des Clubs</h1>
      <p className="lead text-center">
        Découvrez les règles à suivre pour la bonne gestion des clubs, les normes de sécurité, et le respect des locaux.
      </p>
      
      <hr />

      {/* Gestion des clubs */}
      <section className="mb-5">
        <h2 className="text-primary">Gestion des Clubs</h2>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>1. Constitution du Bureau :</strong> Chaque club doit avoir un président, un secrétaire, et un trésorier.
          </li>
          <li className="list-group-item">
            <strong>2. Réunions :</strong> Le club doit tenir au moins une réunion par trimestre pour discuter de la gestion du club.
          </li>
          <li className="list-group-item">
            <strong>3. Projets :</strong> Le club doit tenir à jour ses projets ainsi que leurs évolutions.
          </li>
          <li className="list-group-item">
            <strong>4. Budget :</strong> Chaque club doit gérer son budget avec transparence.
          </li>
          <li className="list-group-item">
            <strong>5. Activités :</strong> Toutes les activités organisées par le club doivent être validées par la direction de l'établissement d'être exécutées.
          </li>
        </ul>
      </section>

      {/* Normes de Sécurité */}
      <section className="mb-5">
        <h2 className="text-primary">Normes de Sécurité</h2>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>1. Équipements :</strong> Tout matériel utilisé doit être vérifié avant chaque utilisation.
          </li>
          <li className="list-group-item">
            <strong>2. Encadrement :</strong> Un adulte responsable doit toujours être présent lors des activités sportives, mais n'est pas nécessaire pour les autres activités.
          </li>
          <li className="list-group-item">
            <strong>4. Limites de capacité :</strong> Le nombre de participants doit respecter les normes de sécurité du lieu où se déroule l'activité.
          </li>
        </ul>
      </section>

      {/* Respect des Locaux */}
      <section className="mb-5">
        <h2 className="text-primary">Respect des Locaux</h2>
        <ul className="list-group">
          <li className="list-group-item">
            <strong>1. Propreté :</strong> Les locaux doivent être laissés dans l'état où ils ont été trouvés. Toute dégradation sera à la charge du club.
          </li>
          <li className="list-group-item">
            <strong>2. Usage des salles :</strong> Les salles ne doivent être utilisées que pour les activités autorisées et réservées par le club.
          </li>
          <li className="list-group-item">
            <strong>3. Accès aux équipements :</strong> Les équipements fournis par l'établissement ne doivent être utilisés qu'avec l'autorisation du personnel et selon les règles en vigueur.
          </li>
          <li className="list-group-item">
            <strong>4. Dégradations :</strong> Toute dégradation des locaux ou des équipements doit être immédiatement signalée à l'administration.
          </li>
        </ul>
      </section>

      <div className="text-center">
        <p className="text-muted">Le non-respect de ces règles entraînera des sanctions allant de l'avertissement à la suspension du club.</p>
      </div>
    </div>
  );
}

export default ReglementsClubs;
